import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/hooks";
import { IRootState } from "../../../types/redux/IRootStore";
import {
    setModified,
    setModalPallets,
    closeModalRedux as closeModal} from "../../../redux/slices/modalPallets2.feature";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import { parseBool } from "../../../aplUtils/extensions";
import { getParamByTypeNumber } from "../../../aplUtils/aplParametersHelper";
import { AplParameter } from "../../../types/aplParameter";
import { PalletDetail } from "../../../types/palletDetail";
import React from "react";
import { createPartPalletReduxCache } from "../../../redux/slices/palletCache.feature";
import { translateString } from "../../../translations/gridTranslationHelper";
import { truncateString } from "../../../aplUtils/stringUtills";
import Spinner from "../Spinner";

export default function ModalPartPallet2() {
    const modalPallets2Redux = useSelector((state: IRootState) => state.modalPallets2);
    const dispatch = useAppDispatch();

    const aplSettings = AplSettingsSelector();
    const modalAplParameters = useSelector((state: IRootState) => state.auth.aplParameters);
    const showCommentBox = parseBool(getParamByTypeNumber(modalAplParameters, aplSettings.siteId, AplParameter.ShowCommentDelete));
    const commentBoxRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
    const initialBoxRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;

    const handleCommentUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
        let pallets: PalletDetail[] = JSON.parse(JSON.stringify(modalPallets2Redux.pallets));
        pallets.map(x => (x.palletUpdateComment = `${initial} ${comment}`));
        dispatch(setModalPallets(pallets));
        dispatch(setModified(true));
    };

    const [initial, setInitial] = React.useState<string>(truncateString(aplSettings.userName, 6).truncated);
    const [comment, setComment] = React.useState<string>("");

    const handleYes = async () => {
        if (showCommentBox && commentBoxRef.current.value.trim().length === 0) {
            commentBoxRef.current.className = "modalReason form-control is-invalid";
            return;
        }
        dispatch(setModified(true));
        let data = modalPallets2Redux.pallets.map(x => ({ ...x }));
        dispatch(createPartPalletReduxCache(data) as any);
    };

    return (
        <React.Fragment>
            <div className="modal-header">
                <h5>{translateString("partPallet", aplSettings.culture)}</h5>
                <button
                    type="button"
                    className="close"
                    onClick={() => {
                        dispatch(closeModal());
                    }}
                >
                    <span aria-hidden="true" className="text-danger">
                        ×
                    </span>
                    <span className="sr-only">Close</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="overflow-none" style={{ maxHeight: "40rem" }} id="modal-overflow">
                    {modalPallets2Redux.message && (
                        <div className="alert alert-danger" role="alert">
                            {modalPallets2Redux.message}
                        </div>
                    )}
                    <div className="m-2">{modalPallets2Redux.pallets.map(x => x.sscc).join(", ")}</div>

                    {modalPallets2Redux.pallets.length > 0 ? (
                        <React.Fragment>
                            <div className="m-2">
                                <div className="row">
                                    <div className="col-4">
                                        <label className="m-2" htmlFor="modal-part-pallet-layers">
                                            {translateString("layers", aplSettings.culture)}
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control ${!modalPallets2Redux.pallets[0]?.layers ? "is-invalid" : ""}`}
                                            id="modal-part-pallet-layers"
                                            value={modalPallets2Redux.pallets[0]?.layers ?? 0}
                                            onChange={e => {
                                                let pallets: PalletDetail[] = JSON.parse(JSON.stringify(modalPallets2Redux.pallets));
                                                pallets = pallets.map(x => ({
                                                    ...x,
                                                    actualQty: x.qtyPerLayer * e.currentTarget.valueAsNumber,
                                                    layers: e.currentTarget.valueAsNumber
                                                }));
                                                dispatch(setModalPallets(pallets));
                                            }}
                                        ></input>
                                    </div>

                                    <div className="col-4">
                                        <label className="m-2" htmlFor="modal-part-pallet-qty-per-layer">
                                            {translateString("pieces", aplSettings.culture)}
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="modal-part-pallet-qty-per-layer"
                                            value={modalPallets2Redux.pallets[0]?.qtyPerLayer ?? 0}
                                            readOnly={true}
                                            onChange={() => {}}
                                        ></input>
                                    </div>

                                    <div className="col-4">
                                        <label className="m-2" htmlFor="modal-part-pallet-qty">
                                            {translateString("quantity", aplSettings.culture)}
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control ${!modalPallets2Redux.pallets[0]?.actualQty ? "is-invalid" : ""}`}
                                            id="modal-part-pallet-qty"
                                            value={modalPallets2Redux.pallets[0]?.actualQty ?? 0}
                                            onChange={e => {
                                                let pallets: PalletDetail[] = JSON.parse(JSON.stringify(modalPallets2Redux.pallets));
                                                pallets = pallets.map(x => ({
                                                    ...x,
                                                    actualQty: e.currentTarget.valueAsNumber,
                                                    layers: Math.ceil(e.currentTarget.valueAsNumber / x.qtyPerLayer)
                                                }));
                                                dispatch(setModalPallets(pallets));
                                            }}
                                        ></input>
                                    </div>
                                </div>
                            </div>

                            <div className="m-2">
                                <div className="row">
                                    <div className="col-4">
                                        <div id="modalComment" style={{ display: "block" }}>
                                            <label htmlFor="modal-dialog-initial">{translateString("initials", aplSettings.culture)}</label>
                                            <input
                                                name="modal-dialog-initial"
                                                type="text"
                                                id="modal-dialog-initial"
                                                maxLength={255}
                                                className={`form-control ${initial.trim() === "" ? "is-invalid" : ""}`}
                                                onChange={e => {
                                                    setInitial(e.currentTarget.value);
                                                    handleCommentUpdate(e);
                                                }}
                                                value={initial}
                                                ref={initialBoxRef}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-8">
                                        <div id="modalComment" style={{ display: "block" }}>
                                            <label htmlFor="modal-dialog-comment">{translateString("comment", aplSettings.culture)}</label>
                                            <input
                                                name="modal-dialog-comment"
                                                type="text"
                                                id="modal-dialog-comment"
                                                maxLength={255}
                                                className="modalReason form-control"
                                                onChange={e => {
                                                    setComment(e.currentTarget.value);
                                                    handleCommentUpdate(e);
                                                }}
                                                ref={commentBoxRef}
                                                value={comment}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <Spinner visible={true} />
                    )}
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        dispatch(closeModal());
                    }}
                >
                    {translateString("close", aplSettings.culture)}
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleYes}
                    disabled={comment.trim() === "" || initial.trim() === ""}
                >
                    {translateString("inBoundBtnOk", aplSettings.culture)}
                </button>
            </div>
        </React.Fragment>
    );
}
